import classNames from 'classnames';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';

export function QuotePanelModalCloseButton({ onClick }: { onClick: () => void }) {
  const { textColor } = useQuote();
  return (
    <button
      type="button"
      className="btn btn-flat-secondary btn-md btn-icon"
      data-bs-dismiss="modal"
      aria-label="Close"
      onClick={onClick}
    >
      <i className={classNames('icon icon-md', textColor)}>clear</i>
    </button>
  );
}
